import { ParamsList } from '../../validator/shared';

export const paramsList: ParamsList = [
    { keyName: 'canonicalUrl', isRequired: true },
    { keyName: 'deviceType', isRequired: true },
    { keyName: 'gaPageType', isRequired: true },
    { keyName: 'priceInPence', isRequired: false },
    { keyName: 'imageUrl', isRequired: false },
    { keyName: 'sellerType', isRequired: true },
    { keyName: 'encryptedVrnCarMoney', isRequired: false },
    { keyName: 'mileageValue', isRequired: false },
    { keyName: 'accountId', isRequired: false },
    { keyName: 'l1Category', isRequired: false },
    { keyName: 'l2Category', isRequired: false },
];

export default paramsList;
